import {Table, Thead, Th, Tbody, Tr, Td, Box} from '@chakra-ui/react';
import {useTranslate} from '@eksab/i18n';
import {useGameQuery} from '../hooks/useGameQuery';

export function MatchBreakdownTable({gameId}: {gameId: string}) {
  const gameQuery = useGameQuery({game: gameId}, 'participant', {enabled: !!gameId});
  const t = useTranslate();
  return (
    <Box overflow="scroll">
      <Table borderRadius="sm" overflow="hidden" variant="striped">
        <Thead bgColor="gray.800" color="white">
          <Th fontSize="sm" textTransform="capitalize">
            {t('competition.matches.player')}
          </Th>
          <Th fontSize="sm" textTransform="capitalize">
            {t('competition.matches.playing_time')}
          </Th>
          <Th fontSize="sm" textTransform="capitalize">
            {t('competition.matches.goals')}
          </Th>
          <Th fontSize="sm" textTransform="capitalize">
            {t('competition.matches.assists')}
          </Th>
          <Th fontSize="sm" textTransform="capitalize">
            {t('competition.matches.cleansheets')}
          </Th>
          <Th fontSize="sm" textTransform="capitalize">
            {t('competition.matches.penalties')}
          </Th>
          <Th fontSize="sm" textTransform="capitalize">
            {t('competition.matches.cards')}
          </Th>
          <Th fontSize="sm" textTransform="capitalize">
            {t('competition.matches.successful_passes')}
          </Th>
        </Thead>
        <Tbody>
          {gameQuery.data?.score_breakdown?.map((row) => (
            <Tr key={row.player.id}>
              <Td>{row.player.common_name}</Td>
              <Td>{row.stats['playing-time']}</Td>
              <Td>{row.stats.goals}</Td>
              <Td>{row.stats.assists}</Td>
              <Td>{row.stats.cleansheets}</Td>
              <Td>{row.stats.penalties}</Td>
              <Td>{row.stats.cards}</Td>
              <Td>{row.stats['successful-passes']}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
}
